/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export default function InfoIcon({ width, height, color, tooltip }) {
  useEffect(() => {
    if (typeof $ === 'undefined') return;

    if (tooltip) {
      $('[data-toggle="m-popover"]').each(function initPopover() {
        const el = $(this);
        const skin = el.data('skin')
          ? `m-popover--skin-${el.data('skin')}`
          : '';

        el.popover({
          trigger: 'hover',
          template: `\
            <div class='m-popover ${skin} popover' role='tooltip'>\
                <div class='arrow'></div>\
                <h3 class='popover-header'></h3>\
                <div class='popover-body'></div>\
            </div>`,
        });
      });
    }
  }, [tooltip]);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-toggle={tooltip ? 'm-popover' : undefined}
      data-content={tooltip || ''}
    >
      <path
        d="M10 0.5C8.02219 0.5 6.08879 1.08649 4.4443 2.1853C2.79981 3.28412 1.51809 4.8459 0.761209 6.67317C0.00433284 8.50043 -0.193701 10.5111 0.192152 12.4509C0.578004 14.3907 1.53041 16.1725 2.92894 17.5711C4.32746 18.9696 6.10929 19.922 8.0491 20.3079C9.98891 20.6937 11.9996 20.4957 13.8268 19.7388C15.6541 18.9819 17.2159 17.7002 18.3147 16.0557C19.4135 14.4112 20 12.4778 20 10.5C20 9.18678 19.7413 7.88642 19.2388 6.67317C18.7363 5.45991 17.9997 4.35752 17.0711 3.42893C16.1425 2.50035 15.0401 1.76375 13.8268 1.2612C12.6136 0.758658 11.3132 0.5 10 0.5ZM11 14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73479 15.5 9.48043 15.3946 9.2929 15.2071C9.10536 15.0196 9 14.7652 9 14.5V9.5C9 9.23478 9.10536 8.98043 9.2929 8.79289C9.48043 8.60536 9.73479 8.5 10 8.5C10.2652 8.5 10.5196 8.60536 10.7071 8.79289C10.8946 8.98043 11 9.23478 11 9.5V14.5ZM10 7.5C9.80222 7.5 9.60888 7.44135 9.44443 7.33147C9.27999 7.22159 9.15181 7.06541 9.07613 6.88268C9.00044 6.69996 8.98063 6.49889 9.01922 6.30491C9.05781 6.11093 9.15305 5.93275 9.2929 5.79289C9.43275 5.65304 9.61093 5.5578 9.80491 5.51921C9.9989 5.48063 10.2 5.50043 10.3827 5.57612C10.5654 5.65181 10.7216 5.77998 10.8315 5.94443C10.9414 6.10888 11 6.30222 11 6.5C11 6.76522 10.8946 7.01957 10.7071 7.20711C10.5196 7.39464 10.2652 7.5 10 7.5Z"
        fill={color}
      />
    </svg>
  );
}

InfoIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  tooltip: PropTypes.string,
};

InfoIcon.defaultProps = {
  width: 20,
  height: 21,
  color: '#1DC2FF',
  tooltip: '',
};
